import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

const Toaster = (props) => {
  const { theme = "system" } = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 640px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  return (
    <Sonner
      theme={theme}
      richColors
      // keep your original top-right but correct the offset for notches
      position="top-right"
      closeButton={false} // <- remove Sonner close button
      visibleToasts={isMobile ? 2 : 4}
      gap={isMobile ? 10 : 12}
      offset={
        isMobile
          ? {
              top: "max(14px, env(safe-area-inset-top))",
              right: "max(14px, env(safe-area-inset-right))",
              left: 14,
            }
          : { top: 16, right: 16 }
      }
      toastOptions={{
        className:
          "w-[calc(100vw-1.5rem)] max-w-[26rem] sm:w-[26rem] !p-0 !bg-transparent !shadow-none",
        classNames: {
          toast:
            "w-[calc(100vw-1.5rem)] max-w-[26rem] sm:w-[26rem] !p-0 !bg-transparent !shadow-none",
          content: "w-full",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
